import { serialize } from '../utils/serialize.js';
import { BaseError } from './base.js';

class HttpRequestError extends BaseError {
    constructor({ body, cause, details, headers, status, url, }) {
        super("HTTP request failed.", {
            cause,
            details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${url}`,
                body && `Request body: ${serialize(body)}`,
            ].filter(Boolean),
            name: "HttpRequestError",
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class RpcRequestError extends BaseError {
    constructor({ body, error, url, }) {
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [`URL: ${url}`, `Request body: ${serialize(body)}`],
            name: "RpcRequestError",
        });
        this.code = error.code;
        this.data = error.data;
    }
}
class TimeoutError extends BaseError {
    constructor({ body, url, }) {
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [`URL: ${url}`, `Request body: ${serialize(body)}`],
            name: "TimeoutError",
        });
    }
}

export { HttpRequestError, RpcRequestError, TimeoutError };
//# sourceMappingURL=request.js.map
